import AppConsts from './../lib/appconst';
import { Modal,message } from 'antd';
import axios from 'axios';
import qs from 'qs';
import { L } from '../lib/abpUtility';
declare var abp: any;

axios.defaults.baseURL = AppConsts.remoteServiceBaseUrl;
axios.defaults.timeout = 60000;
axios.defaults.paramsSerializer = (params) => {
  return qs.stringify(params, {
    encode: false,
  });
}
//请求拦截器
export const handleRequestInterceptor = (config) => {
  const token = abp.auth.getToken();
  if (!!token) {
    config.headers.common['Authorization'] = 'Bearer ' + token;
  }
  // config.headers.common['.AspNetCore.Culture'] = 'zh-Hans';
  config.headers.common['.AspNetCore.Culture'] = abp.utils.getCookieValue('Abp.Localization.CultureName');
  config.headers.common['X-Language'] = abp.utils.getCookieValue('Abp.Localization.CultureName');
  config.headers.common['Abp.TenantId'] = abp.multiTenancy.getTenantIdCookie();

  if (config.url.toLowerCase().includes("stream")) {
    config.responseType = 'blob';
  }

  return config;

}

//响应成功拦截器
export const handleResponseFulfilled = response => {
  // 检测响应头是否为文件流
  const contentType = response.headers['content-type'];
  if (contentType && contentType.includes('application/octet-stream')) {
    // 提取文件名，这里假设服务器通过 Content-Disposition 发送文件名
    const disposition = response.headers['content-disposition'];
    let filename = '';
    if (disposition) {
      const filenameRegex = /filename\*=UTF-8''(.+)/;
      const matches = filenameRegex.exec(disposition);
      if (matches != null && matches[1]) {
        filename = decodeURIComponent(matches[1]);
      }
    }
    // 创建一个 Blob 对象，并使用 URL.createObjectURL 创建一个指向该 Blob 的 URL
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename); // 设置下载的文件名
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url); // 清理资源
    if(navigator.userAgent.indexOf('Firefox') > -1) {
      message.success('文件下载完成,检查下载管理器')
    }
    // return Promise.reject('文件下载中...'); // 可以选择返回一个拒绝的 Promise，防止后续代码执行
  }

  const { __abp, unAuthorizedRequest, targetUrl, success, result, error } = response.data;
  if (__abp) {
    if (success) {      
      response.data = result;
    }
    else {
      Modal.error({
        title: L('ServiceException'),
        content: L('ServiceException2'),
        onOk: (close) => {
          if (unAuthorizedRequest) {
            window.location.href = "/exception?type=403";
          }
          else if (targetUrl) {
            window.location.href = targetUrl;
          }
          return Promise.resolve(true);
        }
      });
    }
  }
  return response;
}

//清除所有cookie函数
function clearAllCookie() {
  var date = new Date();
  date.setTime(date.getTime() - 10000);
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  keys.forEach(name => abp.utils.deleteCookie(name, '/'));
}
//清除所有存储
export function clearAllStorage() {
  localStorage.clear();
  sessionStorage.clear();
  abp.auth.clearToken();
  clearAllCookie();
}
//响应失败拦截器
export const handleResponseRejected = error => {
  const status = error?.response?.status ?? null;
  const dataError = error?.response?.data?.error;
  const unAuthorizedRequest = error?.response?.data?.unAuthorizedRequest;
  const targetUrl = error?.response?.data?.targetUrl;

  if (status === 401) {
    const requestUrl = (error?.config?.url || '').toString();
    // 启动前维护检查可能未登录，跳过 401 跳转，避免 GetMaintainInfo → / → 再请求 的死循环
    if (requestUrl.toLowerCase().includes('getmaintaininfo')) {
      return Promise.reject(error);
    }
    const path = window.location.pathname || '';
    // 回调页、静默续期页：绝不清存储/跳转
    if (
      path.indexOf('/account/callback') >= 0 ||
      path.indexOf('/account/slientcallback') >= 0
    ) {
      return Promise.reject(error);
    }
    // 刚登录成功后的 401（例如会话尚未绑定）：只抛错，避免 clear → 回 IDP 死循环
    if (sessionStorage.getItem('oidc_signin_handled')) {
      console.error('API 401 after OIDC login; skip re-auth redirect', error);
      return Promise.reject(error);
    }
    clearAllStorage();
    if (path !== '/' && path !== '') {
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
  if (dataError) {
    const code = dataError.code;
    if (dataError.code === 200) {
      message.warning(dataError.message)
    } else if (dataError.code === 400) {
      message.error(dataError.message)
    } else if (dataError.code === -1) {
      throw { message: dataError.message, errorCode: dataError.code };
    } else {
      Modal.warning({
        title: L('ExceptionMessage'),
        content: dataError.message,
        closable: true,
        onOk: (close) => {
          if (unAuthorizedRequest) {
            window.location.href = `/exception?type=${code}`;
          }
          else if (targetUrl) {
            window.location.href = targetUrl;
          }
          return Promise.resolve(true);
        }
      });
    }
  }

  return Promise.reject(error);
}

axios.interceptors.request.use(handleRequestInterceptor);
axios.interceptors.response.use(handleResponseFulfilled, handleResponseRejected);
export default axios;
